import { render, staticRenderFns } from "./DetailAvatar.vue?vue&type=template&id=369f6cb2&scoped=true&"
import script from "./DetailAvatar.vue?vue&type=script&lang=ts&"
export * from "./DetailAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./DetailAvatar.vue?vue&type=style&index=0&id=369f6cb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369f6cb2",
  null
  
)

export default component.exports